import Api from "./Api";
import { createQueryString } from "./ApiHelper";

export default {
  GetGlobalOptions() {
    return Api().get(`/global_options`);
  },
  GetCurrency({ curr_id }) {
    return Api().get(`/api/cinema/currency/${curr_id}`);
  }
};



// WEBPACK FOOTER //
// ./src/services/GlobalServices.js